import { useCallback, useRef, useState } from "react";

export function useHistory(initial) {
  const [state, setState] = useState(initial);
  const cur = useRef(initial);
  const past = useRef([]);
  const future = useRef([]);

  const commit = (next) => { cur.current = next; setState(next); };

  const set = useCallback((fn, record = true) => {
    const prev = cur.current;
    const next = typeof fn === "function" ? fn(prev) : fn;
    if (record) {
      past.current.push(prev);
      if (past.current.length > 150) past.current.shift();
      future.current = [];
    }
    commit(next);
  }, []);

  const checkpoint = useCallback(() => { past.current.push(cur.current); future.current = []; }, []);
  const endChange = useCallback(() => {
    if (past.current[past.current.length - 1] === cur.current) past.current.pop();
    setState(cur.current);
  }, []);
  const undo = useCallback(() => {
    if (!past.current.length) return;
    future.current.push(cur.current);
    commit(past.current.pop());
  }, []);
  const redo = useCallback(() => {
    if (!future.current.length) return;
    past.current.push(cur.current);
    commit(future.current.pop());
  }, []);
  const reset = useCallback((v) => { past.current = []; future.current = []; commit(v); }, []);

  return { state, set, checkpoint, endChange, undo, redo, reset, canUndo: past.current.length > 0, canRedo: future.current.length > 0 };
}
